<template>
  <el-container style="height:100%">
    <el-aside class="elaside" style="width:460px;">
      <el-container>
        <el-header>
          <img class="logo" src="../../img/login/1504011.png" />
        </el-header>
        <el-main>
          <div style="display:flex;flex-direction:column;">
            <span class="text1" style="margin-top:220px;">易指云KIS</span>
            <span class="text2" style="margin-top:10px;">让工作触手可及，与金蝶KIS系列产品无缝对接</span>
            <span class="text2" style="margin-top:20px;"><i class="el-icon-circle-check"></i>&nbsp;&nbsp;相同的基础资料&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="el-icon-circle-check"></i>&nbsp;&nbsp;相同的权限配置</span>
            <span class="text2"><i class="el-icon-circle-check"></i>&nbsp;&nbsp;相同的单据配置&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="el-icon-circle-check"></i>&nbsp;&nbsp;相同的审批流程</span>
          </div>
        </el-main>
        <el-footer style="height: 110px;">
          <div>
            <span class="text3">版权所有©重庆方奥软件开发有限公司2021</span>
          </div>
          <div>
            <span class="text3">服务热线:023-68961179</span>
          </div>
          <div>
            <span class="text3">备案号：<a href="https://beian.miit.gov.cn/" target="_blank" style="color:rgba(197, 197, 197, 100);">渝ICP备11002115号</a>   |   <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010702502190" target="_blank" style="color:rgba(197, 197, 197, 100);">渝公网安备 50010702502190号</a></span>
          </div>
        </el-footer>
      </el-container>
    </el-aside>
    <el-main style="height:100%">
      <div class="indexbox_index">
        <div class="loginBox">
          <div class="login-container_index">
            <div class="title-container">
              <h3 :class="ViewType === 0 ? 'title' : 'title_2'" @click="ViewType=0;ButText='登录'" v-if="ViewType==0||ViewType==1">
                密码登录
              </h3>
              <h3 :class="ViewType === 1 ? 'title' : 'title_2'" @click="ViewType=1;ButText='登录'" v-if="ViewType==0||ViewType==1">
                验证码登录
              </h3>
              <h3 class="title" v-if="ViewType==2">
                账号注册
              </h3>
              <h3 class="title" v-if="ViewType==3">
                重置密码
              </h3>
            </div>
            <el-form ref="loginForm" :model="loginForm" class="login-form" autocomplete="on" label-position="left">
              <el-form-item prop="username">
                  <el-input
                  ref="username"
                  prefix-icon="el-icon-user-solid"
                  v-model="loginForm.username"
                  placeholder="请输入手机号"
                  name="username"
                  type="text"
                  tabindex="1"
                  autocomplete="on"
                  />
              </el-form-item>

              <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual v-if="ViewType == 1||ViewType == 2||ViewType == 3">
                  <el-form-item prop="yzm" style="display:flex;flex-direction:row;">
                      <el-input
                          ref="yzm"
                          v-model="loginForm.yzm"
                          placeholder="请输入验证码"
                          name="yzm"
                          tabindex="2"
                          autocomplete="on"
                          @keyup.native="checkCapslock"
                          @blur="capsTooltip = false"
                          @keyup.enter.native="GetApply"
                          style="width:200px;"
                      />
                      <el-button type="info" style="width:124px;" tabindex="3" :loading="loading" plain @click="GetApply">{{ApplyButText}}</el-button>
                  </el-form-item>
              </el-tooltip>

              <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual v-if="ViewType == 0||ViewType == 2||ViewType == 3">
                  <el-form-item prop="password">
                  <el-input
                      :key="passwordType"
                      ref="password"
                      v-model="loginForm.password"
                      :type="passwordType"
                      placeholder="请输入密码"
                      name="password"
                      tabindex="2"
                      autocomplete="on"
                      @keyup.native="checkCapslock"
                      @blur="capsTooltip = false"
                      @keyup.enter.native="handleLogin"
                  />
                  <span class="show-pwd" @click="showPwd">
                      <svg-icon :icon-class="passwordType === 'password' ? 'eye-open' : 'eye'" />
                  </span>
                  </el-form-item>
              </el-tooltip>

              <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin">{{ButText}}</el-button>
              <el-link style="float:left;" @click="ViewType=2;ButText='账号注册'" v-if="ViewType==0 || ViewType==1" type="primary">账号注册</el-link>
              <el-checkbox style="float:left;" v-if="ViewType==2"></el-checkbox><el-link href="http://app.appkingdee.com/agreement.htm" target="_blank" style="float:left;" v-if="ViewType==2" type="primary" >同意《易指云KIS用户协议》</el-link>
              <el-link style="float:right;"  v-if="ViewType == 0"  @click="ViewType=3;ButText='重置密码'">忘记密码</el-link>
              <el-link style="float:right;"  v-if="ViewType == 2"  @click="ViewType=0;ButText='登录'">已有账号</el-link>
              <el-link style="float:left;"  v-if="ViewType == 3"  @click="ViewType=0;ButText='登录'" type="primary">直接登录</el-link>
            </el-form>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { Post } from '../../api/saasapi'
import md5 from 'js-md5'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        username: '',
        password: '',
        yzm: '',
        logintype: 0
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      ViewType: 0, // 0密码登录 1验证码登录 2注册 3重置密码
      ButText: '登录',
      ApplyButText: '获取验证码',
      ApplyTime: 120,
      ApplyTimeNow: 1,
      ApplyTimeer: null
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created () {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted () {
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
  },
  destroyed () {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    checkCapslock (e) {
      const { key } = e
      this.capsTooltip =
                key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin () {
      // ViewType:0,//0密码登录 1验证码登录 2注册 3重置密码
      // 密码登录
      if (this.ViewType == 0) {
        if (this.loginForm.username == '') {
          this.$message.error('请输入手机号!')
          return
        }
        if (this.loginForm.password == '') {
          this.$message.error('请输入密码!')
          return
        }
        this.loading = true
        this.loginForm.logintype = this.ViewType
        this.$store
          .dispatch('user/enterpriseLogin', this.loginForm)
          .then((res) => {
            if (res.Code == 0 || res.Code == 2006) {
              this.$router.push({
                path: '/main',
                query: this.otherQuery
              })
            } else {
              this.$message.error(res.Message)
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      } else if (this.ViewType == 1) {
        if (this.loginForm.username == '') {
          this.$message.error('请输入手机号!')
          return
        }
        if (this.loginForm.yzm == '') {
          this.$message.error('请输入验证码!')
          return
        }
        this.loading = true
        this.loginForm.logintype = this.ViewType
        this.$store
          .dispatch('user/enterpriseLogin', this.loginForm)
          .then((res) => {
            if (res.Code == 0 || res.Code == 2006) {
              this.$router.push({
                path: '/main',
                query: this.otherQuery
              })
            } else {
              this.$message.error(res.Message)
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      } else if (this.ViewType == 2) {
        if (this.loginForm.username == '') {
          this.$message.error('请输入手机号!')
          return
        }
        if (this.loginForm.yzm == '') {
          this.$message.error('请输入验证码!')
          return
        }
        if (this.loginForm.password == '') {
          this.$message.error('请输入密码!')
          return
        }
        this.loading = true
        this.loginForm.logintype = this.ViewType
        Post('Shuangquan.DealerManagement.Admin.Base.Users', 'users/registuser', {PhoneNumber: this.loginForm.username, VerifyCode: this.loginForm.yzm, Password: md5(this.loginForm.password)})
          .then(response => {
            if (response.Code != 0) {
              this.$message.warning(response.Message)
            } else {
              this.$message.success('用户注册成功，请登录。')
              this.ViewType = 0
              this.ButText = '登录'
            }
            this.loading = false
          })
          .catch(error => {
            this.$message.error(error)
            this.loading = false
          })
      } else if (this.ViewType == 3) {
        if (this.loginForm.username == '') {
          this.$message.error('请输入手机号!')
          return
        }
        if (this.loginForm.yzm == '') {
          this.$message.error('请输入验证码!')
          return
        }
        if (this.loginForm.password == '') {
          this.$message.error('请输入密码!')
          return
        }
        this.loading = true
        this.loginForm.logintype = this.ViewType
        Post('Shuangquan.DealerManagement.Admin.Base.Users', 'users/resetpassword', {PhoneNumber: this.loginForm.username, VerifyCode: this.loginForm.yzm, NewPassword: md5(this.loginForm.password)})
          .then(response => {
            if (response.Code != 0) {
              this.$message.warning(response.Message)
            } else {
              this.$message.success('用户重置成功，请登录。')
              this.ViewType = 0
              this.ButText = '登录'
            }
            this.loading = false
          })
          .catch(error => {
            this.$message.error(error)
            this.loading = false
          })
      }
    },
    getOtherQuery (query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    GetApply () {
      var ApiUrl = 'users/applyloginverifycode'// 登录获取验证码
      if (this.ViewType == 2) { ApiUrl = 'users/applyregist' }// 注册获取验证码
      if (this.ViewType == 3) { ApiUrl = 'users/ApplyResetPassword' }// 重置密码获取验证码
      if (this.ApplyTimeNow != 1) { return }
      if (this.loginForm.username == '') {
        this.$message.error('请输入手机号!')
        return
      }
      this.loading = true
      Post('Shuangquan.DealerManagement.Admin.Base.Users', ApiUrl, {PhoneNumber: this.loginForm.username})
        .then(response => {
          if (response.Code != 0) {
            this.$message.warning(response.Message)
          } else {
            this.$message.success('验证码发送成功请注意查收。')
            this.ApplyTimeer = setInterval(this.OnApplyTime, 1000)
          }
          this.loading = false
        })
        .catch(error => {
          this.$message.error(error)
          this.loading = false
        })
    },
    OnApplyTime () {
      if (this.ApplyTimeNow < this.ApplyTime) {
        this.ApplyButText = (this.ApplyTime - this.ApplyTimeNow) + '后可重发'
        this.ApplyTimeNow++
      } else {
        this.ApplyButText = '获取验证码'
        this.ApplyTimeNow = 1
        clearInterval(this.ApplyTimeer)
        this.ApplyTimeer = null
      }
    }
  }
}
</script>
<style lang="scss">
$bg: #fff;
$light_gray: #000;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
    .login-container_index .el-input input {
        color: $cursor;
    }
}
.elaside{
  width:462px;
  height:100%;
  background:url('../../img/login/4601024.jpg');
  display:flex;
  flex-direction:column;
}

.logo{
  margin-top:29px;
}

.text1{
  color: rgba(255, 255, 255, 100);
  font-size: 32px;
  text-align: left;
  font-family: Roboto-regular;
}

.text2{
  color: rgba(255, 255, 255, 100);
  font-size: 14px;
  text-align: left;
  font-family: Roboto-regular;
}

.text3{
  color: rgba(197, 197, 197, 100);
  font-size: 12px;
  text-align: left;
  font-family: Roboto-regular;
}

.indexbox_index {
    width: 100;
    height: 100%;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    .loginBox{
        width: 410px;
        height: 60%;
        background-color: #fff;
        //display: flex;
        flex-direction: row;
        .left_img{
          //height: 100%;
          text-align:center;
        }

    }
}
/* reset element-ui css */
.login-container_index {
    .el-form-item {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.1);
        border-radius: 5px;
        color: #454545;
    }
    .el-select {
        width: 100%;
    }
}
</style>

<style lang="scss" scoped>
$bg: #fff;
$dark_gray: #889aa4;
$light_gray: #0a5a1cd8;

.login-container_index {
    min-height: 100%;
    width: 100%;
    background-color: $bg;
    overflow: hidden;

    .login-form {
        position: relative;
        width: 400px;
        max-width: 100%;
        padding: 0px 35px 0;
        margin: 0 auto;
        overflow: hidden;
    }

    .tips {
        font-size: 14px;
        color: #fff;
        margin-bottom: 10px;

        span {
            &:first-of-type {
                margin-right: 16px;
            }
        }
    }

    .svg-container {
        padding: 6px 5px 6px 15px;
        color: $dark_gray;
        vertical-align: middle;
        width: 30px;
        display: inline-block;
    }

    .title-container {
        position: relative;
        display: flex;
        width: 400px;
        .title {
            font-size: 26px;
            color: #000000;
            margin: 0px auto 40px auto;
            text-align: center;
            font-family: Roboto-bold;
            float:left;
        }
        .title_2 {
            font-size: 26px;
            color: #999999;
            margin: 0px auto 40px auto;
            text-align: center;
            font-family: Roboto-bold;
            float:right;
        }
    }

    .show-pwd {
        position: absolute;
        right: 10px;
        top: 2px;
        font-size: 16px;
        color: $dark_gray;
        cursor: pointer;
        user-select: none;
    }

    .yzm {
      width: 60%;
      float: left;
    }
    .yzm_img {
      height: 47px;
      float: right;
    }

    .thirdparty-button {
        position: absolute;
        right: 0;
        bottom: 6px;
    }

    @media only screen and (max-width: 470px) {
        .thirdparty-button {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue